import { observer } from 'mobx-react-lite'
import { MandatoryFieldsSubtitle } from '../MandatoryFieldsSubtitle'
import styles from './InvalidFieldsSubtitle.module.css'

interface InvalidFieldsSubtitleProps {
  hasError: boolean
}

export const InvalidFieldsSubtitle = observer(function InvalidFieldsSubtitle({
  hasError,
}: InvalidFieldsSubtitleProps) {
  if (hasError) {
    return (
      <p className={styles.error}>
        Please resolve the errors below before saving
      </p>
    )
  }

  return <MandatoryFieldsSubtitle />
})
